import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import PictionJS from 'piction-js';
import { Table } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import Loader from '../ui/Loader';
import UMOGridItem from '../UMOGridItem';
import UMOGridNoJItem from '../UMOGridNoJItem';
import { viewTypes } from '../../constants/umoGallery';
import piction from '../../utils/piction';
import { AlternatesTag, SearchParams } from '../../utils/searchUtils';
import UMOListItem from '../UMOListItem';
import UMOGridNoJItemSmall from '../UMOGridNoJItemSmall';
import UMOGallerySortView from '../UMOGallerySortView';

class UMOGridLayout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isJGLoaded: false,
    };
    this.fixImageRatio = this.fixImageRatio.bind(this);
    this.retrieveAlternateUMOs = this.retrieveAlternateUMOs.bind(this);
  }

  componentDidMount() {
    const $this = this;
    window.addEventListener('resize', $this.adjustCols.bind(this));
  }

  componentDidUpdate(prevProps) {
    const umoGalleryEl = $('.umo-gallery');
    const thisObj = this;

    if (this.props.viewType !== viewTypes.GRID || this.props.isSortMode || this.props.isLoading) {
      if ($('.umo-gallery.justified-gallery').length > 0) {
        umoGalleryEl.justifiedGallery('destroy');
      }
      this.adjustCols();
    } else if (prevProps.umoList !== this.props.umoList ||
      prevProps.viewType !== this.props.viewType ||
      prevProps.isSortMode !== this.props.isSortMode) {
      // only refresh justified gallery when the umoList has changed OR
      // view type has changed from not justified to justified
      umoGalleryEl.css({ opacity: 0, visibility: 'hidden' });
      umoGalleryEl.justifiedGallery('destroy');
      umoGalleryEl.justifiedGallery({
        rowHeight: 200,
        maxRowHeight: null,
        cssAnimation: true,
        margins: 15,
        lastRow: 'nojustify',
        randomize: false,
        waitThumbnailsLoad: false,
      }).on('jg.complete', () => {
        umoGalleryEl.addClass('umo-gallery--loaded').removeAttr('style');
        this.fixImageRatio();
        thisObj.setState({
          isJGLoaded: true,
        });
      }).on('jg.resize', () => {
        this.fixImageRatio();
      });
    }
  }

  componentWillUnmount() {
    // need to turn off the jg.complete event handler since it has a setState inside. we don't
    // want the setState to trigger if the component is unmounted.
    $('.umo-gallery').justifiedGallery('destroy').off('jg.complete');
  }

  /* Hack to fix images in justified gallery with height/width ratio of more than 0.25
    i.e very long and short images
    images with extreme ratios (extremely long) were modified in umoGridItem.jsx with fake ratio
    this is a fix to modify them back to original ratio so image isn't distorted */
  fixImageRatio() {
    const wideThumbsToFix = $('img[data-wide-thumb-fix-ratio]');
    let tempItem;
    let tempStyleWidth;
    let tempRatio;
    if (wideThumbsToFix.length > 0) {
      for (let i = 0; i < wideThumbsToFix.length; i++) {
        tempItem = $(wideThumbsToFix[i]);
        tempRatio = parseFloat(tempItem.attr('data-wide-thumb-fix-ratio'));
        tempItem.attr('height', (parseInt(tempItem.attr('width')) * tempRatio));

        tempStyleWidth = parseInt(tempItem.css('width').split('px')[0]);

        tempItem.css('height', tempStyleWidth * tempRatio);
        tempItem.css('margin-top', 0);
      }
    }
  }

  updateDimensions() {
    this.adjustCols.bind(this);
  }

  adjustCols() {
    const updateGalleryMain = $('.main__umo-gallery');
    const updateGalleryEl = $('.umo-gallery');
    updateGalleryEl.find('.umo-grid-item-noj').removeAttr('style');
    if (this.props.isNotJustified && updateGalleryEl.find('.umo-grid-item-noj')) {
      const boxView = Math.floor(updateGalleryMain.width());
      const boxWidth = updateGalleryMain.find('.umo-grid-item-noj') ?
        Math.floor(updateGalleryMain.find('.umo-grid-item-noj').outerWidth(true)) : '';
      const countBox = boxWidth ? Math.floor(boxView / boxWidth) : '';
      if (countBox) {
        updateGalleryMain.find('.umo-grid-item-noj').outerWidth(Math.floor(boxView / countBox) - 20);
      }
    }
  }

  retrieveAlternateUMOs(umoID) {
    this.props.retrieveUMOs(new SearchParams({
        tagList: [new AlternatesTag(
          umoID,
          'Alternate Images',
          umoID,
          <FormattedMessage id="umoGridItem.alternateItemTagLabel" />,
          <FormattedMessage id="umoGridItem.alternateItemTagDescription" />
        )],
      })
    );
  }

  render() {
    let umoItems = [];
    let tempUMO;
    let isSelected;
    if (this.props.isSortMode) {
      umoItems = (
        <UMOGallerySortView
          umoList={this.props.umoList}
          customMetatag={this.props.customMetatag}
          categoryID={this.props.searchParams && this.props.searchParams.get('tagList')[0].value}
        />);
    } else {
      for (let i = 0; i < this.props.umoList.size; i += 1) {
        tempUMO = new PictionJS.UMO(this.props.umoList.get(i)
          .toJS(), { hostURL: piction.hostURL });
        isSelected = this.props.selectedUMOIDs.includes(tempUMO.id);
        isSelected = this.props.isSelectAll ? !isSelected : isSelected;

        switch (this.props.viewType) {
          case (viewTypes.SM_GRID_NOJ):
            umoItems.push(<UMOGridNoJItemSmall
              key={tempUMO.id}
              umo={tempUMO}
              umoRatings={this.props.umoRatings}
              searchParams={this.props.searchParams}
              selectedUMOIDs={this.props.selectedUMOIDs}
              isSelectAll={this.props.isSelectAll}
              isSelected={isSelected}
              isUMOGalleryWorkspace={this.props.isUMOGalleryWorkspace}
              onDetailViewClick={this.props.onDetailViewClick}
              toggleFullImageView={this.props.toggleFullImageView}
              selectedWorkspaceData={this.props.selectedWorkspaceData}
              retrieveAlternateUMOs={this.retrieveAlternateUMOs}
              dispatch={this.props.dispatch}
              workspaceCardsViewTimes={this.props.workspaceCardsViewTimes}
              highlightSetID={this.props.highlightSetID}
              galleryType={this.props.galleryType}
            />);
            break;
          case (viewTypes.GRID):
            umoItems.push(<UMOGridItem
              key={tempUMO.id}
              umo={tempUMO}
              customMetatag={this.props.customMetatag}
              searchParams={this.props.searchParams}
              selectedUMOIDs={this.props.selectedUMOIDs}
              isSelectAll={this.props.isSelectAll}
              isSelected={isSelected}
              isLoaded={this.state.isJGLoaded}
              isUMOGalleryWorkspace={this.props.isUMOGalleryWorkspace}
              onDetailViewClick={this.props.onDetailViewClick}
              toggleFullImageView={this.props.toggleFullImageView}
              selectedWorkspaceData={this.props.selectedWorkspaceData}
              retrieveAlternateUMOs={this.retrieveAlternateUMOs}
              dispatch={this.props.dispatch}
              workspaceCardsViewTimes={this.props.workspaceCardsViewTimes}
              isNotJustified={false}
              highlightSetID={this.props.highlightSetID}
              galleryType={this.props.galleryType}
            />);
            break;
          case (viewTypes.LIST):
            umoItems.push(<UMOListItem
              key={tempUMO.id}
              umo={tempUMO}
              customMetatag={this.props.customMetatag}
              searchParams={this.props.searchParams}
              selectedUMOIDs={this.props.selectedUMOIDs}
              isSelectAll={this.props.isSelectAll}
              isSelected={isSelected}
              isLoaded={this.state.isJGLoaded}
              isUMOGalleryWorkspace={this.props.isUMOGalleryWorkspace}
              onDetailViewClick={this.props.onDetailViewClick}
              toggleFullImageView={this.props.toggleFullImageView}
              selectedWorkspaceData={this.props.selectedWorkspaceData}
              retrieveAlternateUMOs={this.retrieveAlternateUMOs}
              dispatch={this.props.dispatch}
              workspaceCardsViewTimes={this.props.workspaceCardsViewTimes}
              highlightSetID={this.props.highlightSetID}
              galleryType={this.props.galleryType}
              isNotJustified
            />);
            break;
          case (viewTypes.GRID_NOJ):
            umoItems.push(<UMOGridNoJItem
              key={tempUMO.id}
              umo={tempUMO}
              umoRatings={this.props.umoRatings}
              customMetatag={this.props.customMetatag}
              searchParams={this.props.searchParams}
              selectedUMOIDs={this.props.selectedUMOIDs}
              isSelectAll={this.props.isSelectAll}
              isSelected={isSelected}
              isUMOGalleryWorkspace={this.props.isUMOGalleryWorkspace}
              onDetailViewClick={this.props.onDetailViewClick}
              toggleFullImageView={this.props.toggleFullImageView}
              selectedWorkspaceData={this.props.selectedWorkspaceData}
              retrieveAlternateUMOs={this.retrieveAlternateUMOs}
              dispatch={this.props.dispatch}
              workspaceCardsViewTimes={this.props.workspaceCardsViewTimes}
              highlightSetID={this.props.highlightSetID}
              galleryType={this.props.galleryType}
            />);
            break;
          default:
            break;
        }
      }
    }

    return (
      <div className="umo-gallery">
        {
          // eslint-disable-next-line no-nested-ternary
          this.props.isLoading ?
            <Loader className="umo-gallery__loader" isLarge wrapperClass="loader-wrapper" /> :
            this.props.viewType === viewTypes.LIST ?
              <div className="table-responsive" style={{ overflowX: 'hidden' }}>
                <Table className="umo-gallery__list-view-tbl">
                  <tbody>
                    {umoItems}
                  </tbody>
                </Table>
              </div>
              :
              umoItems
        }
      </div>
    );
  }
}

UMOGridLayout.propTypes = {
  umoList: PropTypes.instanceOf(List),
  selectedUMOIDs: PropTypes.instanceOf(List),
  searchParams: PropTypes.instanceOf(SearchParams),
  onDetailViewClick: PropTypes.func,
  dispatch: PropTypes.func,
  toggleFullImageView: PropTypes.func,
  isLoading: PropTypes.bool,
  isNotJustified: PropTypes.bool,
  isSelectAll: PropTypes.bool,
  isUMOGalleryWorkspace: PropTypes.bool,
  selectedWorkspaceData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
  }),
  customMetatag: PropTypes.string,
  umoRatings: PropTypes.object,
  workspaceCardsViewTimes: PropTypes.shape({
    catid: PropTypes.string,
    usernm: PropTypes.string,
    viewtimes: PropTypes.array,
  }),
  viewType: PropTypes.string,
  highlightSetID: PropTypes.string,
  galleryType: PropTypes.string,
  isSortMode: PropTypes.bool,
  retrieveUMOs: PropTypes.func,
};

export default UMOGridLayout;



// WEBPACK FOOTER //
// ./src/js/components/UMOGallery/UMOGridLayout.jsx